import { styled, Grid } from '@mui/material';
import React from 'react';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, WIDGET_MEDIA_BORDER_RADIUS, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';
import { checkAndAppendRoutePrefixToLink } from '../../utils/widgetUtils.js';

var _a;
var SixRectangleBoxesContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: '5%',
            paddingRight: '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
        },
        _b["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var Boxes = styled(Grid)((_a = {
        paddingLeft: 20,
        paddingRight: 20,
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        textAlign: 'center',
        fontSize: 50,
        fontWeight: 700,
        lineHeight: 1.2,
        gridTemplateColumns: 'repeat(3, 1fr)'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        gridTemplateColumns: 'repeat(1, 1fr)',
        fontSize: 26,
        padding: '0 20px',
    },
    _a));
var SingleBoxContainer = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        alignItems: 'flex-start',
        width: '100%',
        minWidth: 250,
        margin: '0',
        img: {
            display: 'block',
            aspectRatio: '2',
            width: '100%',
        },
        '.imgContainer': {
            width: '100%',
            borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
            overflow: 'hidden',
        },
        '.title': {
            fontSize: 22,
            fontWeight: 600,
            color: theme.palette.primary.main,
            margin: '20px 0',
            textAlign: 'left',
        },
    });
});
var SingleBox = function (_a) {
    var title = _a.title, link = _a.link, image = _a.image, LinkComponent = _a.LinkComponent;
    return (React.createElement(LinkComponent, { className: "text-link-wrapper image-link-hover-wrapper", to: link, style: { textDecoration: 'none' } },
        React.createElement(SingleBoxContainer, { container: true, flexDirection: 'column' },
            React.createElement("div", { className: "imgContainer" },
                React.createElement("img", { className: "image-link-hover", loading: "lazy", src: image, alt: "6RBox" })),
            React.createElement("div", { className: "title text-link" }, title))));
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var SixRectangleBoxes = function (_a) {
    var brandEntity = _a.brandEntity, items = _a.items, LinkComponent = _a.LinkComponent, routePrefix = _a.routePrefix;
    return (React.createElement(SixRectangleBoxesContainer, null,
        React.createElement(Boxes, { display: "grid", gap: '7px 20px' }, items === null || items === void 0 ? void 0 : items.map(function (item, idx) {
            var _a;
            return (React.createElement(Grid, { key: idx },
                React.createElement(SingleBox, { title: item === null || item === void 0 ? void 0 : item.title, link: checkAndAppendRoutePrefixToLink("".concat((brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.id) || ''), routePrefix, ((_a = item === null || item === void 0 ? void 0 : item.link) === null || _a === void 0 ? void 0 : _a.id) || ''), image: item === null || item === void 0 ? void 0 : item.image, LinkComponent: LinkComponent })));
        }))));
};
//

export { SixRectangleBoxes };
//# sourceMappingURL=index.js.map
